// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAzksdjil-oz5yrPO7ZClfZ5TDONLK1fmk",
  authDomain: "ayyo-e1455.firebaseapp.com",
  projectId: "ayyo-e1455",
  storageBucket: "ayyo-e1455.appspot.com",
  messagingSenderId: "1089653941622",
  appId: "1:1089653941622:web:9dae95474e704378c1c657",
  measurementId: "G-GDVD2S7MDM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
